import close from "../assets/icon/exit.png";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router";
import { pageIndicator } from "../apollo";
import { FormError2 } from "../components/form-error";
import {
  EditProductProps,
  GoodStatusOption,
  GoodStatusOptionType,
  relatedProps,
  TagList,
} from "../constants/enum";
import { IEditGoodFormProps, useEditGood } from "../hooks/useEditGood";
import { useGetGood } from "../hooks/useGetGood";
import { Button } from "../components/button";
import { useListCorporationSelect } from "../hooks/useListCorprationSelect";
import { Autocomplete, Switch, TextField } from "@mui/material";

import del from "../assets/icon/exit.png";
import { useCrGoodOption } from "../hooks/useCrGoodOption";
import { useListGoodOption } from "../hooks/useListGoodOption";
import moment from "moment";
import { useDelGoodOption } from "../hooks/useDelGoodOption";
import { useEditGoodOption } from "../hooks/useEditGoodOption";
import {
  CrGoodOptionMutation,
  DelGoodOptionMutation,
  DetailedGoodOptionInput,
  EditGoodInput,
  EditGoodMutation,
  EditGoodOptionInput,
  EditGoodOptionMutation,
  GetGoodInput,
  GetGoodQuery,
  GoodOption,
  GoodStatus,
  ListCorporationSelectQuery,
  ListGoodAllQuery,
  ListGoodOptionQuery,
  ListSubCategoryQuery,
  Tags,
} from "../generated/graphql";
import { useListSubCategory } from "../hooks/useListSubCategory";
import CreatableSelect from "react-select/creatable";

export interface corporationProps {
  label: string;
  value: number;
}

export const SubAdminEditProductInfo: React.FC<EditProductProps> = ({
  tabs,
  setTabHandler,
}) => {
  // 태그
  const isInitialMount = useRef(true); // 렌더링 여부를 확인할 ref 생성
  const [tags, setTags] = useState<Tags[]>([]);
  const completed = (data: ListSubCategoryQuery) => {
    const {
      listSubCategory: { ok, err, subCategories },
    } = data;
    if (ok) {
      setSubCategories(subCategories || []);
    } else {
      setSubCategories([]);
    }
  };
  const [
    listSubCategory,
    { data: subCategoryData, loading: subCategoryLoading },
  ] = useListSubCategory(completed);

  const [subCategories, setSubCategories] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<any | null>(null);

  const [cor, setCor] = useState<any[]>([]);
  const addTagHandler = (values: Tags) => {
    setTags([...tags, values]);
  };
  const removeTagHandler = (values: Tags) => {
    setTags(tags.filter((a) => a !== values));
  };
  // 글자 수
  const getByte = (str: string) => {
    var bytes = str
      .split("")
      .map((s) => s.charCodeAt(0))
      .reduce((prev, c) => prev + (c === 10 ? 2 : c >> 7 ? 2 : 1), 0);
    return bytes;
  };
  const params = useParams();

  /// 거래처 List ///
  const onListCorporation = (data: ListCorporationSelectQuery) => {
    const {
      listCorporationSelect: { ok, err, corporations },
    } = data;
    if (ok) {
      setCor(corporations || []);
    }
  };
  const [
    listCorporationSelect,
    { data: corporation },
  ] = useListCorporationSelect(onListCorporation);

  /// 거래처 List ///
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    control,
    formState: { errors, isValid },
  } = useForm<IEditGoodFormProps>({ mode: "all" });

  const onGetComplete = (data: GetGoodQuery) => {
    const {
      getGood: { ok, err, good },
    } = data;

    if (ok && good) {
      setValue("summary", good.summary);
      setValue("weight", good.weight);
      if (good.tags) {
        setTags(good.tags);
      }
      setValue("title", good.title);
      if (good.corporation?.name) {
        setSelectedValue(good.corporation);
      }

      setValue("expirydate", `${moment(good.expirydate).format("YYYY-MM-DD")}`);

      setValue("status", good.status ? good.status : GoodStatus.GoodReady);
      setValue("price", good.price);
      if (good.limitNumOrders) {
        setValue("limitNumOrders", good.limitNumOrders);
        setLimitCheck(true);
      }
      setValue("discountRate", good.discountRate);
      if (good.subCategory) {
        setValue("subCategory", {
          value: good.subCategory?.id ? good.subCategory?.name.toString() : null,
          label: good.subCategory?.name || "",
        });
      }
      listCorporationSelect();
      listGoodOptionHandler(good.id);
      listSubCategory({
        variables: {
          input: {
            corporationId: good.corporation?.id,
          },
        },
      });
    } else {
      alert("잘못된 접근입니다");
      window.location.href = "/product";
      return;
    }
  };

  // 상품 정보
  const [getGood, { data, loading, called }] = useGetGood(onGetComplete);
  const getGoodHandler = (goodId: number) => {
    const getGoodInput: GetGoodInput = {
      goodId,
    };
    getGood({ variables: { input: getGoodInput } });
  };

  const onEditComplete = async (data: EditGoodMutation) => {
    const {
      editGood: { ok, err },
    } = data;
    if (ok) {
      editGoodOptionHandler();
    } else {
      alert(err);
    }
  };
  const [editGood, { loading: editGoodLoading }] = useEditGood(onEditComplete);

  const onSubmit = () => {
    if (!params.goodId) return;
    if (!editGoodLoading) {
      const {
        weight,

        summary,
        expirydate,
        title,
        // corporationId,
        status,
        subCategory,
        price,
        discountRate,
        limitNumOrders,
      } = getValues();
      const editGoodInput: EditGoodInput = {
        weight: weight ? +weight : null,
        tags: tags,
        summary,
        expirydate,
        title,
        status: status as GoodStatus,
        limitNumOrders: limitCheck ? Number(limitNumOrders) : 0,
        corporationId: +selectedValue?.id,
        price: price ? +price : 1,
        discountRate: discountRate ? +discountRate : 0,
        id: +params.goodId,
        subCategoryName: subCategory ? subCategory.value : null,
      };
      editGood({ variables: { input: editGoodInput } });
    }
  };
  useEffect(() => {
    // 1. selectedValue에 유효한 값이 있을 때 (객체가 선택되었을 때)
    if (selectedValue?.id) {
      // selectedValue의 id를 사용하여 listSubCategory 함수를 호출합니다.
      listSubCategory({
        variables: {
          input: {
            corporationId: selectedValue.id,
          },
        },
      });
    }
    // 2. selectedValue가 null일 때 (선택이 해제되었을 때)
    else {
      setSubCategories([]);
      // 필요하다면, 카테고리 목록을 비우는 로직을 추가할 수 있습니다.
      // 예: setSubCategoryOptions([]);
    }
  }, [selectedValue, listSubCategory]); // selectedValue가 바뀔 때마다 이 effect가 실행됩니다.

  useEffect(() => {
    if (!params.goodId) return;
    const goodId = +params.goodId;
    // listCorporationSelect();
    getGoodHandler(goodId);
    pageIndicator("product");
  }, []);

  // 옵션
  const [goodOptionsArray, setGoodOptionArray] = useState<
    ListGoodOptionQuery["listGoodOption"]["goodOptions"]
  >([]);
  const listGoodOptionCompleted = (data: ListGoodOptionQuery) => {
    const {
      listGoodOption: { ok, err, goodOptions },
    } = data;
    if (ok && goodOptions) {
      setGoodOptionArray(goodOptions);
    } else {
      alert(err);
    }
  };
  const [
    listGoodOption,
    { data: listGoodOptions, refetch: goodOptionsRefetch },
  ] = useListGoodOption(listGoodOptionCompleted);
  const listGoodOptionHandler = (goodId: number) => {
    listGoodOption({
      variables: { input: { goodId } },
    });
  };
  const CrGoodOptionCompleted = async (data: CrGoodOptionMutation) => {
    const {
      crGoodOption: { ok, err },
    } = data;
    if (ok) {
      await goodOptionsRefetch();
    } else {
      alert(err);
    }
  };
  const [crGoodOption] = useCrGoodOption(CrGoodOptionCompleted);
  const CrGoodOptionHandelr = (goodId: number) => {
    crGoodOption({
      variables: { input: { goodId } },
    });
  };
  const delGoodOptionCompleted = async (data: DelGoodOptionMutation) => {
    const {
      delGoodOption: { ok, err },
    } = data;
    if (ok) {
      await goodOptionsRefetch();
    } else {
      alert(err);
    }
  };
  const [delGoodOption] = useDelGoodOption(delGoodOptionCompleted);
  const delgoodOptionHandler = (goodOptionId: number) => {
    delGoodOption({
      variables: { input: { goodOptionId } },
    });
  };

  const editGoodOptionCompleted = (data: EditGoodOptionMutation) => {
    const {
      editGoodOption: { ok, err },
    } = data;
    if (ok) {
      alert("저장되었습니다");
      setTabHandler(tabs + 1);
    } else {
      alert(err);
    }
  };
  const [editGoodOption] = useEditGoodOption(editGoodOptionCompleted);
  const editGoodOptionHandler = () => {
    var goodOptions: DetailedGoodOptionInput[] = [];
    if (!goodOptionsArray) return;
    for (const goodOption of goodOptionsArray) {
      console.log(goodOption.price);
      var _goodOption: DetailedGoodOptionInput = {
        id: goodOption.id,
        name: goodOption.name,
        price: goodOption.price,
        count: goodOption.count,
        deliveryDate: goodOption.dateActive ? goodOption.deliveryDate : null,
        dateActive: goodOption.dateActive,
        isEvent: goodOption.isEvent,
        discountRate: goodOption.discountRate,
      };
      goodOptions.push(_goodOption);
    }
    const editGoodOptionInput: EditGoodOptionInput = {
      detailedGoodOptions: goodOptions,
    };
    editGoodOption({
      variables: { input: editGoodOptionInput },
    });
  };

  // 수량 제한
  const [limitCheck, setLimitCheck] = useState(
    getValues().limitNumOrders ? true : false
  );

  const optionActiveHandler = (optionId: number) => {
    if (!goodOptionsArray) return;
    const newOption = goodOptionsArray.map((option) => {
      if (optionId === option.id) {
        var changed = { ...option };
        if (option.dateActive) {
          changed = {
            ...option,
            dateActive: !option.dateActive,
            deliveryDate: null,
          };
        } else {
          changed = {
            ...option,
            dateActive: !option.dateActive,
          };
        }
        return { ...option, ...changed };
      }
      return option;
    });
    setGoodOptionArray(newOption);
  };
  const optionActiveEventHandler = (optionId: number) => {
    if (!goodOptionsArray) return;
    const newOption = goodOptionsArray.map((option) => {
      if (optionId === option.id) {
        var changed = { ...option };
        if (option.isEvent) {
          changed = {
            ...option,
            isEvent: !option.isEvent,
          };
        } else {
          changed = {
            ...option,
            isEvent: !option.isEvent,
          };
        }
        return { ...option, ...changed };
      }
      return option;
    });
    setGoodOptionArray(newOption);
  };

  return (
    <div className="shadow-lg min-w-[1160px] min-h-[800px] h-fix-content max-w-[1160px]  2xl:max-w-[1623px]  bg-white">
      <form onSubmit={handleSubmit(onSubmit)} id="update">
        <div className="pl-9 pr-11 py-8 space-y-4">
          <div className="space-y-2">
            <div className="font-bold text-[#4F4F4F] text-base">상품명</div>
            <input
              {...register("title", {
                required: `상품명을 입력해주세요`,
              })}
              type="text"
              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
            />
            {errors.title?.message && (
              <FormError2 errorMessage={errors.title.message} />
            )}
          </div>

          <div className="grid grid-cols-2 gap-x-6">
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">상품설명</div>
              <input
                {...register("summary", {
                  required: "상품설명을 입력해주세요",
                })}
                type="text"
                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
              ></input>
              {errors.summary?.message && (
                <FormError2 errorMessage={errors.summary.message} />
              )}
            </div>
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">무게</div>
              <div className="flex flex-wrap">
                <input
                  {...register("weight", {})}
                  type="number"
                  defaultValue={0}
                  className="border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                ></input>
                <p className="pl-2 my-2">g</p>
              </div>
              {errors.weight?.message && (
                <FormError2 errorMessage={errors.weight.message} />
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-x-6"></div>

          <div className=" grid grid-cols-3 gap-x-6">
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base flex flex-wrap justify-between">
                <p>
                  <span className="align-middle">판매수량제한</span>
                  <input
                    type="checkbox"
                    checked={limitCheck}
                    onChange={(e) => {
                      // console.log();
                      setLimitCheck(e.target.checked);
                    }}
                    className="align-middle ml-2 w-4 h-4"
                  />
                </p>
              </div>
              <div>
                <input
                  {...register("limitNumOrders")}
                  type="number"
                  className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                  disabled={!limitCheck}
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-6">
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">
                판매 상태
              </div>
              <div className="grid grid-cols-4">
                {Object(GoodStatusOption).map(
                  (goodStatus: GoodStatusOptionType, index: number) => (
                    <div key={`product-status-${index}`} className="">
                      <input
                        {...register(`status`, {})}
                        className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                        type="radio"
                        name="status"
                        id={goodStatus.label}
                        value={goodStatus.value}
                      ></input>
                      <label htmlFor={goodStatus.label} className="px-2">
                        {goodStatus.label}
                      </label>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-6">
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">
                거래처 이름
              </div>
              <div className="w-full">
                <Autocomplete
                  // value prop에는 객체 또는 null이 전달됨
                  value={selectedValue}
                  onChange={(event, newValue) => {
                    // onChange의 newValue도 객체 또는 null임
                    setSelectedValue(newValue);
                    setValue("subCategory", undefined);
                  }}
                  // options는 객체 배열
                  options={cor}
                  // 추가: 옵션 객체에서 화면에 표시할 문자열을 반환하는 방법을 알려줌
                  getOptionLabel={(option) => option.name || ""}
                  // 추가: value 객체와 options 내의 객체를 비교하는 방법을 알려줌
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disablePortal
                  autoComplete
                  sx={{ padding: 0 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      placeholder="등록할 거래처를 적어주세요"
                    />
                  )}
                />
              </div>
            </div>
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">
                상품 카테고리
              </div>
              <Controller
                name="subCategory" // react-hook-form 필드 이름 확인
                control={control}
                render={({ field }) => (
                  <CreatableSelect
                    {...field}
                    isClearable
                    // 3. (변경) 로딩 상태와 플레이스홀더를 개선합니다.
                    isLoading={subCategoryLoading}
                    placeholder={
                      subCategoryLoading
                        ? "카테고리 불러오는 중..."
                        : "카테고리를 선택하거나 직접 입력하세요..."
                    }
                    options={subCategories.map((category) => ({
                      value: category.name,
                      label: category.name,
                    }))}
                    formatCreateLabel={(inputValue) =>
                      `"${inputValue}" 새로 만들기`
                    }
                  />
                )}
              />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-x-6">
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">판매가</div>
              <div className="flex flex-wrap">
                <input
                  {...register("price", {
                    required: `가격을 입력해주세요`,
                  })}
                  type="number"
                  defaultValue={0}
                  className="border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                ></input>
                <p className="pl-2 my-2">원</p>
              </div>
              {errors.price?.message && (
                <FormError2 errorMessage={errors.price.message} />
              )}
            </div>
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">할인율</div>
              <div className="flex flex-wrap">
                <input
                  {...register("discountRate", {
                    required: `할인율을 입력해주세요`,
                  })}
                  type="number"
                  step=""
                  defaultValue={0}
                  min={0}
                  max={100}
                  className="border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                ></input>
                <p className="pl-2 my-2">%</p>
              </div>
              {errors.discountRate?.message && (
                <FormError2 errorMessage={errors.discountRate.message} />
              )}
            </div>
            <div className="space-y-2">
              <div className="font-bold text-[#4F4F4F] text-base">최종가격</div>
              <div className="flex flex-wrap">
                <p className="border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-2 px-4 ">
                  {data?.getGood.good?.price &&
                    (data.getGood.good.price *
                      (100 - Number(data.getGood.good.discountRate))) /
                      100}
                </p>
                <p className="pl-2 my-2">원</p>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <div className="font-bold text-[#4F4F4F] text-base">태그</div>

            <div className="pt-4 flex flex-wrap content-center gap-x-4">
              {TagList.map((tag) => (
                <label key={`tags-${tag.name}`} className="text-lg">
                  <input
                    checked={tags.includes(tag.value)}
                    onChange={() => {
                      if (tags.includes(tag.value)) {
                        removeTagHandler(tag.value);
                      } else {
                        addTagHandler(tag.value);
                      }
                    }}
                    type="checkbox"
                    value={tag.value}
                  />
                  <span className="pl-2">{tag.name}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="space-y-2">
            <div className="font-bold text-[#4F4F4F] text-base inline-block">
              옵션{" "}
            </div>
            <button
              type="button"
              onClick={() => {
                CrGoodOptionHandelr(Number(data?.getGood?.good?.id));
              }}
              className="ml-4 px-3 bg-back text-white rounded-md"
            >
              추가
            </button>
            <div className="text-sm text-gray-400">
              분을 제외한 시간 단위로 저장됩니다.
            </div>
            <div className="pt-4  space-y-2 w-full">
              {goodOptionsArray &&
                goodOptionsArray.length > 0 &&
                goodOptionsArray.map((option, index) => (
                  <div
                    key={`goodOptions-${option.id}-${index}`}
                    className="text-sm text-darkFont py-1 px-2  space-x-2 inlie-flex flex-wrap content-center"
                  >
                    <div className="flex flex-wrap gap-x-2">
                      <div className="font-bold p-1 w-20 text-[#4F4F4F] text-base">
                        이벤트
                      </div>
                      <div className="font-bold p-1 w-96 text-[#4F4F4F] text-base">
                        옵션명
                      </div>
                      <div className="font-bold p-1 w-48 text-[#4F4F4F] text-base">
                        옵션가격
                      </div>
                      <div className="font-bold p-1 w-24 ml-2 text-[#4F4F4F] text-base">
                        할인율
                      </div>
                      <div className="font-bold p-1 w-24 ml-2 text-[#4F4F4F] text-base">
                        수량
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-x-4 ">
                      <Switch
                        checked={option.isEvent}
                        onChange={() => {
                          optionActiveEventHandler(option.id);
                        }}
                      ></Switch>
                      <input
                        type="text"
                        defaultValue={option.name ? `${option.name}` : ""}
                        name={`goodOption${option.id}-editMode`}
                        onChange={(e) => {
                          var options = goodOptionsArray;
                          options[index].name = e.target.value;
                          setGoodOptionArray(options);
                        }}
                        className="w-96 border-2 rounded-sm p-1"
                      />
                      <input
                        type="number"
                        defaultValue={option.price ? `${option.price}` : ""}
                        name={`goodOption${option.id}-editMode`}
                        onChange={(e) => {
                          var options = goodOptionsArray;
                          options[index].price = e.target.valueAsNumber;
                          setGoodOptionArray(options);
                        }}
                        className="w-48 border-2 rounded-sm p-1"
                      />
                      <input
                        type="number"
                        defaultValue={
                          option.discountRate ? `${option.discountRate}` : ""
                        }
                        name={`goodOption${option.id}-editMode`}
                        onChange={(e) => {
                          var options = goodOptionsArray;
                          options[index].discountRate = e.target.valueAsNumber;
                          setGoodOptionArray(options);
                        }}
                        className="w-24 border-2 rounded-sm p-1"
                      />
                      <input
                        type="number"
                        min={0}
                        defaultValue={
                          option.count != null ? `${option.count}` : ""
                        }
                        name={`goodOption${option.id}-editMode`}
                        onChange={(e) => {
                          var options = goodOptionsArray;
                          options[index].count = e.target.valueAsNumber;
                          setGoodOptionArray(options);
                        }}
                        className="w-24 border-2 rounded-sm p-1"
                      />

                      <Switch
                        checked={option.dateActive}
                        onChange={() => {
                          optionActiveHandler(option.id);
                        }}
                      ></Switch>

                      <input
                        type="datetime-local"
                        value={moment(option.deliveryDate).format(
                          "YYYY-MM-DD HH:00"
                        )}
                        onChange={(e) => {
                          const newOption = goodOptionsArray.map(
                            (goodOption) => {
                              if (option.id === goodOption.id) {
                                var changed = {
                                  ...goodOption,
                                  deliveryDate: e.target.value
                                    ? e.target.value
                                    : null,
                                };
                                return { ...goodOption, ...changed };
                              }
                              return goodOption;
                            }
                          );
                          setGoodOptionArray(newOption);
                        }}
                      />

                      <button
                        type="button"
                        onClick={() => {
                          delgoodOptionHandler(option.id);
                        }}
                        className="border rounded-full bg-gray-200"
                      >
                        <img
                          src={close}
                          alt={`removeOption-${index} 번째`}
                          className="inline-block w-full"
                        />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="flex flex-wrap justify-center pt-6">
            <Button
              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
              canClick={true}
              actionText={`등록`}
              loading={loading}
              color={"text-white"}
            />
          </div>
        </div>
      </form>
    </div>
  );
};
